module.exports = __webpack_public_path__ + "img/yuukoukigenn20221114.31936e6e.png";